import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import _ from 'lodash'
import classNames from 'classnames'
import AppBreadCrumbs from 'components/layout/AppBreadCrumbs'
import HelpMenu from 'components/navigation/TopBar/HelpMenu'
import ProfileMenu from 'components/navigation/TopBar/UserMenu'
import logoNew from '@assets/images/v2-dashboard/logo-new.svg'
import style from './style.module.scss'

const HeaderBranding = ({
  showLogo = false,
  afterLogin = false,
  inAuthLoginCheck = false,
  borderLess = false,
}) => {
  const apps = useSelector(state => state.apps)
  const user = useSelector(state => state.user)
  const classes = `col-md-12 col-xl-12 col-sm-12 col-xs-12 pt-0 ${style.HeaderBrandingMain}`
  const location = useLocation()
  const settings = useSelector(state => state.settings)
  const urlParams = _.split(location.pathname, '/')

  const appSections = [
    'overview',
    'credentials',
    'users',
    'groups',
    'roles',
    'ai-features',
    'ai-bots',
    'ai-instructions',
    'analytics',
    'chats',
    'calls',
    'calls-legacy',
    'widgets',
    'ui-kits',
    'sdks',
    'apis',
    'notifications',
    'extensions',
    'webhooks',
    'webhooks-legacy',
    'bots',
    'general',
    'members',
    'plans-billing',
    'integrate',
    'moderation',
  ]
  const appSectionPages = [
    'add',
    'edit',
    'view',
    'detail',
    'install',
    'customize',
    'user',
    'push-notification',
  ]

  const currentAppID = urlParams[2] !== undefined ? urlParams[2] : false
  const currentSection = urlParams[3] !== undefined ? urlParams[3] : false
  const currentSectionPage = urlParams[4] !== undefined ? urlParams[4] : false
  const currentSectionPageInner = urlParams[5] !== undefined ? urlParams[5] : false
  const currentSectionPageInnerAction = urlParams[6] !== undefined ? urlParams[6] : false

  const pageBreadcrumbs = [
    {
      title: 'All Apps',
      url: '/apps',
    },
    {
      title: _.truncate(apps.active.name, {
        length: 20,
        omission: '...',
      }),
      url: `/app/${apps.active.id}/overview`,
    },
  ]

  if (currentAppID && currentSection && _.includes(appSections, currentSection)) {
    if (currentSection === 'integrate') {
      let currentSectionPageFormatted = currentSectionPage
      if (currentSectionPageFormatted === 'sdks') {
        currentSectionPageFormatted = 'SDKs'
      } else if (currentSectionPageFormatted === 'ui-kits') {
        currentSectionPageFormatted = 'UI Kits'
      } else if (currentSectionPageFormatted === 'apis') {
        currentSectionPageFormatted = 'APIs'
      } else if (currentSectionPageFormatted === 'notification') {
        currentSectionPageFormatted = 'Notifications'
      }
      pageBreadcrumbs.push({
        title: currentSectionPageFormatted,
        url: false,
      })
    } else if (currentSection === 'plans-billing') {
      pageBreadcrumbs.push({
        title: 'Plans & Billing',
        url: false,
      })
    } else if (currentSection === 'ai-features') {
      pageBreadcrumbs.push({
        title: 'AI Features',
        url: false,
      })
    } else if (currentSection === 'ai-bots') {
      pageBreadcrumbs.push({
        title: 'AI Bots (Legacy)',
        url: false,
      })
    } else if (currentSection === 'ai-instructions') {
      pageBreadcrumbs.push({
        title: 'AI Instructions (Legacy)',
        url: false,
      })
    } else if (currentSection === 'analytics') {
      pageBreadcrumbs.push({
        title: 'Insights',
        url: false,
      })
    } else if (currentSection === 'calls-legacy') {
      pageBreadcrumbs.push({
        title: 'Calls (Legacy)',
        url: false,
      })
    } else if (currentSection === 'members') {
      pageBreadcrumbs.push({
        title: 'Team Members',
        url: false,
      })
    } else if (_.includes(appSectionPages, currentSectionPage)) {
      pageBreadcrumbs.push({
        title: currentSection,
        url: `/app/${apps.active.id}/${currentSection}`,
      })

      if (currentSectionPage === 'user') {
        pageBreadcrumbs.push({
          title: 'Edit Details',
          url: false,
        })
      } else if (currentSectionPage === 'push-notification') {
        pageBreadcrumbs.push({
          title: 'Push Notifications',
          url: false,
        })
      } else
        pageBreadcrumbs.push({
          title: `${_.capitalize(_.replace(currentSectionPage, '-', ' '))} ${_.capitalize(
            _.replace(currentSection, '-', ' '),
          )}`,
          url: false,
        })
    } else if (currentSectionPageInner) {
      if (currentSection === 'moderation') {
        pageBreadcrumbs.push({
          title: currentSection,
          url: `/app/${apps.active.id}/${currentSection}/${currentSectionPage}`,
        })

        if (currentSectionPageInner === 'add') {
          pageBreadcrumbs.push({
            title: `${currentSectionPageInner} Rule`,
            url: false,
          })
        }
        if (currentSectionPageInnerAction === 'view' || currentSectionPageInnerAction === 'edit') {
          pageBreadcrumbs.push({
            title: `${currentSectionPageInnerAction} Rule`,
            url: false,
          })
        }
      } else {
        pageBreadcrumbs.push({
          title: currentSection,
          url: `/app/${apps.active.id}/${currentSection}`,
        })
      }
      if (currentSectionPageInner === 'edit') {
        pageBreadcrumbs.push({
          title: 'Edit Details',
          url: false,
        })
      } else if (currentSectionPageInner === 'install') {
        pageBreadcrumbs.push({
          title: 'Install',
          url: false,
        })
      } else if (currentSectionPageInner === 'settings') {
        pageBreadcrumbs.push({
          title: 'Settings',
          url: false,
        })
      } else if (currentSectionPageInner === 'customize') {
        pageBreadcrumbs.push({
          title: 'Customize',
          url: false,
        })
      }
    } else {
      pageBreadcrumbs.push({
        title: _.capitalize(_.replace(currentSection, new RegExp('-', 'g'), ' ')),
        url: false,
      })
    }
  }
  function detectMob() {
    return settings.isMobileView
  }

  return (
    <React.Fragment>
      {!afterLogin && (
        <div
          className={classNames(classes, borderLess ? style.HeaderBrandingMainBorderLess : '')}
          style={{ width: 'fit-content' }}
          id="pt-0"
        >
          {location.pathname !== '/create-your-first-application' &&
            location.pathname !== '/schedule-your-kick-off-call' && (
              <Link
                to={inAuthLoginCheck && user.id !== undefined && user.id.length > 0 ? '/apps' : '/'}
                style={{ width: '100%', textAlign: 'left' }}
              >
                <img
                  style={{ width: '128px', fontSize: '600px' }}
                  src={logoNew}
                  alt="cometchatasa"
                />
              </Link>
            )}
          {(location.pathname === '/create-your-first-application' ||
            location.pathname === '/schedule-your-kick-off-call') && (
            <img
              style={{ width: '128px', fontSize: '600px' }}
              src={logoNew}
              alt="cometchatasa"
            />
          )}
        </div>
      )}
      {afterLogin && (
        <div>
          <div
            className={`${style.HeaderBrandingMain} ${
              showLogo ? '' : style.HeaderBrandingMainBorderLess
            }`}
          >
            {!detectMob() &&
              location.pathname !== '/apps' &&
              location.pathname !== '/create-application' &&
              location.pathname !== '/settings' &&
              apps.active.id && (
                <AppBreadCrumbs params={pageBreadcrumbs} className={style.breadcrumbsDes} />
              )}
            {showLogo && (
              <div className={style.HeaderBrandingLogoWrapper}>
                <Link to="/apps" style={{ margin: '0px', lineHeight: '1.4' }}>
                  <img
                    style={{
                      width: '128px',
                      marginLeft: '10px',
                    }}
                    src={logoNew}
                    alt="cometchat"
                  />
                </Link>
              </div>
            )}
            {detectMob() && !showLogo ? (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <div className={style.HeaderBrandingLogoWrapper} style={{}}>
                  <Link to="/apps" style={{ margin: '0px', lineHeight: '1.4' }}>
                    <img
                      style={{
                        width: '128px',
                        marginLeft: '30px',
                      }}
                      src={logoNew}
                      alt="cometchat"
                    />
                  </Link>
                </div>
              </div>
            ) : (
              ''
            )}
            {detectMob() ? (
              <div className={style.HeaderBrandingUserControlsWrapperMob}>
                <div style={{ display: 'flex' }}>
                  <HelpMenu />
                  <div>
                    <ProfileMenu />
                  </div>
                </div>
              </div>
            ) : (
              <div className={style.HeaderBrandingUserControlsWrapperDes}>
                <div style={{ display: 'flex' }}>
                  <div>
                    <HelpMenu style={{ marginRight: '24px' }} />
                  </div>
                  {/* <div>
                      <img
                        style={{ marginRight: '24px' }}
                        src={topNavNotificationIcon}
                        alt="notifications"
                      />
                    </div> */}
                  <div>
                    <ProfileMenu />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {detectMob() &&
      location.pathname !== '/apps' &&
      location.pathname !== '/create-application' &&
      location.pathname !== '/settings' &&
      location.pathname !== '/login' &&
      location.pathname !== '/verify-account' &&
      location.pathname !== '/signup' &&
      apps.active.id ? (
        <AppBreadCrumbs params={pageBreadcrumbs} />
      ) : (
        ''
      )}
    </React.Fragment>
  )
}
export default HeaderBranding
